<template>

  <div class="profile" @click="$router.push({name:'User'})">
    <div class="initials">
      {{ userInitials }}
    </div>
    {{ user.name }}
  </div>

</template>

<script>
import {
  mapState,
  mapGetters
} from 'vuex'

export default {
  name: 'Profile',
  computed: {
    ...mapState(['user']),
    ...mapGetters(['userInitials'])
  }
}
</script>

<style scoped lang="stylus">
.profile
    height 250px
    border-bottom solid 2px #40748a
    color white
    display flex
    flex-direction column
    align-items center
    justify-content center
    img
      margin 20px
      height 90px
    .initials
      height: 100px;
      width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: white;
      color: #004563;
      font-size: 40px;
      border-radius: 50px;
      margin: 20px;
      letter-spacing: -8px;
</style>



// WEBPACK FOOTER //
// src/components/common/Profile.vue